import { Calendar, ArrowRight } from "lucide-react";
import { useT } from "../i18n/useT";

const trustChips = [
  "Data platforms",
  "Cloud architecture",
  "Backend systems",
  "Kafka",
  "Flink",
  "Snowflake",
  "AWS",
  "Kubernetes",
  "Python",
  "Java",
];

export default function Hero() {
  const t = useT();
  return (
    <section id="top" className="relative overflow-hidden">
      <div className="absolute inset-0 grid-noise opacity-40" aria-hidden />
      <div
        className="absolute inset-x-0 -top-24 h-[460px] bg-gradient-to-b from-accent-500/10 via-accent-500/5 to-transparent blur-2xl"
        aria-hidden
      />
      <div className="container-page relative pt-20 pb-24 sm:pt-28 sm:pb-28">
        <div className="max-w-3xl">
          <p className="mb-6 inline-flex items-center gap-2 rounded-full border border-ink-700 bg-ink-900/60 px-3 py-1 text-xs font-medium text-ink-300">
            <span className="size-1.5 rounded-full bg-accent-500" />
            {t.hero.pill}
          </p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight text-ink-50 leading-[1.05]">
            {t.hero.h1Pre}{" "}
            <span className="text-accent-500">{t.hero.h1Highlight}</span>
            {t.hero.h1Post}
          </h1>
          <p className="mt-6 max-w-2xl text-lg text-ink-300 leading-relaxed">{t.hero.sub}</p>
          <p className="mt-4 max-w-2xl text-base text-ink-400 leading-relaxed">{t.hero.sub2}</p>

          <div className="mt-10 flex flex-wrap items-center gap-3">
            <a href="#contact" className="btn-primary">
              <Calendar className="size-4" />
              {t.hero.ctaPrimary}
            </a>
            <a href="#services" className="btn-ghost">
              {t.hero.ctaSecondary}
              <ArrowRight className="size-4" />
            </a>
          </div>

          <ul className="mt-10 flex flex-wrap gap-2 text-xs text-ink-300">
            {trustChips.map((c) => (
              <li
                key={c}
                className="rounded-full border border-ink-800 bg-ink-900/40 px-3 py-1"
              >
                {c}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
